
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

const MenuEditUser = defineComponent({
  name: "MenuDropdown",
  emits: ["openEdit", "copy", "goToPublic", "delete", "rejectCandidate"],
  props: {
    candidateId: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const router = useRouter();
    const isMenuOpen = ref(false);
    const openEdit = () => {
      context.emit("openEdit");
    };
    const copyCandidate = () => {
      context.emit("copy");
      isMenuOpen.value = false;
    };
    const deleteCandidate = () => {
      context.emit("delete");
      isMenuOpen.value = false;
    };
    const closeMenu = () => {
      isMenuOpen.value = false;
    };
    const goToPublic = () => {
      context.emit("goToPublic");
      isMenuOpen.value = false;
    };
    const rejectCandidate = () => {
      context.emit("rejectCandidate");
      isMenuOpen.value = false;
    };

    return {
      isMenuOpen,
      closeMenu,
      openEdit,
      copyCandidate,
      router,
      goToPublic,
      deleteCandidate,
      rejectCandidate,
    };
  },
});
export default MenuEditUser;
